import { axiosSFS, axiosUploadFile, params } from '@/api/instance'

const fetchPax = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchCmtpax = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/comment'
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchPaxsGroup = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/group'
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const updateNoPhoneNumber = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/confirm-phone'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const updatePassenger = (passengerInfo) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret
  return axiosSFS({
    method: 'put',
    url: url,
    data: {
      data: passengerInfo
    }
  }).then(function (response) {
    return response?.data
  })
}

const updateLeadPhoneNumber = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/leader'
  return axiosSFS({
    method: 'patch',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const sendSMSbookroom = (param) => {
  const url = axiosSFS.defaults.baseURL + '/sms/book-room'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const sendSMSshareroom = (param) => {
  const url = axiosSFS.defaults.baseURL + '/sms/share-room'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const updateNewFlight = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/flight'
  return axiosSFS({
    method: 'put',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const storeNps = (param) => {
  const url = axiosSFS.defaults.baseURL + '/nps'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const readMessage = (msgId) => {
  const url = axiosSFS.defaults.baseURL + '/read-message/' + msgId
  return axiosSFS({
    method: 'patch',
    url: url
  }).then(function (response) {
    return response?.data
  })
}

const updateLanguage = (langCode) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/language'
  return axiosSFS({
    method: 'patch',
    url: url,
    data: {
      data: {
        lang_code: langCode
      }
    }
  }).then(function (response) {
    return response?.data
  })
}
const updatePaxsPhone = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/phone'
  return axiosSFS({
    method: 'patch',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const callCancelHotelVouchers = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/cancelHotelVouchers'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const inviteTravelTogether = (param) => {
  const url = axiosSFS.defaults.baseURL + '/sms/travel-together'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const scanStrToPax = (param) => {
  const url = axiosSFS.defaults.baseURL + '/scan-str-to-pax'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const confirmTravelTogether = (param) => {
  const url = axiosSFS.defaults.baseURL + '/confirm-travel-together'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const updateInviteStage = (param) => {
  const url = axiosSFS.defaults.baseURL + '/update-invite'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const fetchInvitedPaxs = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/get-invited'
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}
const confirmManageBook = (param) => {
  const url = axiosSFS.defaults.baseURL + '/confirm-manager-book'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const searchPax = (param) => {
  const url = axiosSFS.defaults.baseURL + '/virtual-support-desk/search'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const searchFlight = (param) => {
  const url = axiosSFS.defaults.baseURL + '/virtual-support-desk/searchFlights'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const modifyGroup = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/modify-group'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: {
        pax_id_group: param.pax_id_group,
        action: param.action
      }
    }
  }).then(function (response) {
    return response?.data
  })
}
const modifyGroupPax = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/modify-group-pax'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: {
        secret: param.secret,
        passengers: param.passengers
      }
    }
  }).then(function (response) {
    return response?.data
  })
}
const sendSMSVirtualHelpDesk = (param) => {
  const url = axiosSFS.defaults.baseURL + '/sms/virtual-helpdesk'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const confirmVirtualHelpDesk = (param) => {
  const url = axiosSFS.defaults.baseURL + '/confirm-virtual-helpdesk'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}
const getShareContact = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/getContactListPassengers'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}
const shareUpdate = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/saveContactListPassengers'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}
const deleteShareContact = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/deleteShareContact'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const updateShareContact = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/updateShareContact'
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}
const storeFile = (data) => {
  const url = axiosUploadFile.defaults.baseURL + '/covid19/store-file'
  return axiosUploadFile({
    method: 'post',
    url: url,
    data: data.formData
  }).then(function (response) {
    return response?.data
  })
}

const updateCheck = (data) => {
  const url = axiosSFS.defaults.baseURL + '/covid19/check-document'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: data.data_form
    }
  }).then(function (response) {
    return response?.data
  })
}

const getDocumentPassenger = (data) => {
  const url = axiosSFS.defaults.baseURL + '/covid19/get-document/' + data.data.secrect
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res.success) {
      return res
    }
  })
}

const deletePassengerDocument = (data) => {
  const url = axiosSFS.defaults.baseURL + '/covid19/delete-document'
  var dataSend = data.data
  return axiosSFS({
    method: 'delete',
    url: url,
    data: {
      data: dataSend
    }
  }).then(function (response) {
    return response?.data
  })
}

const fetchPaxBoarding = () => {
  if (!params.secret || params.secret === 'false') {
    return Promise.resolve({ success: false, message: '' })
  }

  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/boarding'

  return axiosSFS.get(url).then((response) => {
    return response?.data
  })
}

const confirmBoarding = (data) => {
  const url = axiosUploadFile.defaults.baseURL + '/passengers/' + params.secret + '/confirmBoarding'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: data
    }
  }).then(function (response) {
    return response?.data
  })
}

const confirmDetailsVirtualHelpdesk = (data) => {
  const url = axiosSFS.defaults.baseURL + '/confirm-detail-virtual-helpdesk'
  return axiosSFS({
    method: 'post',
    url: url,
    data: data
  }).then(function (response) {
    return response?.data
  })
}

const fetchOverNightStation = () => {
  const url = axiosSFS.defaults.baseURL + '/' + params.secret + '/over-night-station'
  return axiosSFS.get(url).then((response) => {
    return response?.data
  })
}

export {
  fetchPax,
  fetchCmtpax,
  fetchPaxsGroup,
  updateNoPhoneNumber,
  updateLeadPhoneNumber,
  callCancelHotelVouchers,
  sendSMSbookroom,
  sendSMSshareroom,
  updateNewFlight,
  storeNps,
  readMessage,
  updateLanguage,
  updatePaxsPhone,
  inviteTravelTogether,
  confirmTravelTogether,
  confirmManageBook,
  searchPax,
  sendSMSVirtualHelpDesk,
  confirmVirtualHelpDesk,
  updatePassenger,
  getShareContact,
  shareUpdate,
  deleteShareContact,
  storeFile,
  updateShareContact,
  updateCheck,
  getDocumentPassenger,
  deletePassengerDocument,
  fetchPaxBoarding,
  confirmBoarding,
  updateInviteStage,
  fetchInvitedPaxs,
  confirmDetailsVirtualHelpdesk,
  modifyGroupPax,
  modifyGroup,
  scanStrToPax,
  fetchOverNightStation,
  searchFlight
}
